import { apiPost, apiGet, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const fetchInventoriesAPI = (data) => {
  return apiGet('mgmt/inventory', data)
}

export const getWeightTolerancesAPI = () => {
  return apiGet('mgmt/inventory/tolerances')
}

export const getCategoriesAPI = () => {
  return apiGet('mgmt/inventory/categories')
}

export const getCategoryByIdAPI = (id) => {
  return apiGet('mgmt/inventory/categories/' + id)
}

// export const getInventoriesAPI  = (shopId) => {
//     return apiGet('mgmt/inventory?shopId='+(shopId ? shopId : ''))
// }

// Update APIS
export const updateWeightTolerancesAPI = (tolerance) => {
  Hotjar.event('update_weight_tolerance')
  return apiPost(`mgmt/settings/tolerances/${tolerance.id}`, tolerance)
}

export const updateInventoryAPI = (inventory) => {
  Hotjar.event('update_inventory')
  return apiPost(`mgmt/inventory/${inventory.id}`, inventory)
}

export const addNewInventoryAPI = (inventory) => {
  Hotjar.event('add_inventory')
  return apiPost('mgmt/inventory', inventory)
}

export const deleteInventoryAPI = (inventoryId) => {
  Hotjar.event('delete_inventory')
  return apiDelete(`mgmt/inventory/${inventoryId}`)
}

export const loadProductsAPI = (data) => {
  return apiGet(`mgmt/products`, data)
}

export const loadBrandsAPI = (data) => {
  return apiGet(`mgmt/brands/list/brands`, data)
}

export const bulkupdateProductsAPI = (data) => {
  Hotjar.event('bulkupdate_products')
  return apiPut(`mgmt/products/bulkupdate`, data)
}

export const loadProductsByIdAPI = (masterId) => {
  return apiGet(`mgmt/products/${masterId.masterId}`)
}

export const getProductSellAPI = (productId) => {
  return apiGet(`mgmt/productSells/${productId}`)
}

export const getProductAPI = (productId) => {
  return apiGet(`mgmt/products/${productId}`)
}

export function getThirdPartyProducts(brandId, productId) {
  return apiGet(`mgmt/thirdparty/products`, { brandId, productId })
}



// WEBPACK FOOTER //
// ./src/api/inventory.js